require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Add", {
  enumerable: true,
  get: function get() {
    return _add["default"];
  }
});
Object.defineProperty(exports, "Discord", {
  enumerable: true,
  get: function get() {
    return _discord["default"];
  }
});
Object.defineProperty(exports, "Envelope", {
  enumerable: true,
  get: function get() {
    return _envelope["default"];
  }
});
Object.defineProperty(exports, "Facebook", {
  enumerable: true,
  get: function get() {
    return _facebook["default"];
  }
});
Object.defineProperty(exports, "Github", {
  enumerable: true,
  get: function get() {
    return _github["default"];
  }
});
Object.defineProperty(exports, "Instagram", {
  enumerable: true,
  get: function get() {
    return _instagram["default"];
  }
});
Object.defineProperty(exports, "LinkedIn", {
  enumerable: true,
  get: function get() {
    return _linkedin["default"];
  }
});
Object.defineProperty(exports, "Notification", {
  enumerable: true,
  get: function get() {
    return _notification["default"];
  }
});
Object.defineProperty(exports, "Phone", {
  enumerable: true,
  get: function get() {
    return _phone["default"];
  }
});
Object.defineProperty(exports, "Print", {
  enumerable: true,
  get: function get() {
    return _print["default"];
  }
});
Object.defineProperty(exports, "Search", {
  enumerable: true,
  get: function get() {
    return _search["default"];
  }
});
Object.defineProperty(exports, "Share", {
  enumerable: true,
  get: function get() {
    return _share["default"];
  }
});
Object.defineProperty(exports, "Twitch", {
  enumerable: true,
  get: function get() {
    return _twitch["default"];
  }
});
Object.defineProperty(exports, "Twitter", {
  enumerable: true,
  get: function get() {
    return _twitter["default"];
  }
});
Object.defineProperty(exports, "Website", {
  enumerable: true,
  get: function get() {
    return _website["default"];
  }
});
Object.defineProperty(exports, "Whatsapp", {
  enumerable: true,
  get: function get() {
    return _whatsapp["default"];
  }
});
Object.defineProperty(exports, "Youtube", {
  enumerable: true,
  get: function get() {
    return _youtube["default"];
  }
});

var _add = _interopRequireDefault(require("./add"));

var _discord = _interopRequireDefault(require("./discord"));

var _envelope = _interopRequireDefault(require("./envelope"));

var _facebook = _interopRequireDefault(require("./facebook"));

var _github = _interopRequireDefault(require("./github"));

var _instagram = _interopRequireDefault(require("./instagram"));

var _linkedin = _interopRequireDefault(require("./linkedin"));

var _notification = _interopRequireDefault(require("./notification"));

var _phone = _interopRequireDefault(require("./phone"));

var _print = _interopRequireDefault(require("./print"));

var _search = _interopRequireDefault(require("./search"));

var _share = _interopRequireDefault(require("./share"));

var _twitch = _interopRequireDefault(require("./twitch"));

var _twitter = _interopRequireDefault(require("./twitter"));

var _website = _interopRequireDefault(require("./website"));

var _whatsapp = _interopRequireDefault(require("./whatsapp"));

var _youtube = _interopRequireDefault(require("./youtube"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}